import { render, staticRenderFns } from "./MenuMyTeamList.vue?vue&type=template&id=35d29dd3&scoped=true&"
var script = {}
import style0 from "./MenuMyTeamList.vue?vue&type=style&index=0&id=35d29dd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d29dd3",
  null
  
)

export default component.exports